import { Box, theme } from '@factorialco/deprecated-design-system'

import { ModuleCarousel } from 'modules/marketplace_modules/components/Revamp/Carousel'
import { FeatureItem } from 'modules/marketplace_modules/components/Revamp/FeatureBlocks/_Item'

interface ValidFeature {
  emoji: string
  title: string
  description: string
}

interface OverviewLeftColumnProps {
  moduleCarouselVideo?: string | null
  moduleCarouselImages: Array<{ url?: string | null }>
  moduleSlug?: string | null
  validFeatures: ValidFeature[]
}

export const OverviewLeftColumn = ({
  moduleCarouselVideo,
  moduleCarouselImages,
  moduleSlug,
  validFeatures,
}: OverviewLeftColumnProps) => {
  const hasVideo = Boolean(moduleCarouselVideo && String(moduleCarouselVideo).trim())
  const validImages = (moduleCarouselImages ?? []).filter((img) => img?.url)
  const hasEnoughImages = validImages.length > 0
  const showCarousel = hasVideo || hasEnoughImages

  return (
    <Box
      className="product-modal-extended-scroll-column"
      style={{
        flex: '2 1 0%',
        minWidth: '0',
        minHeight: '0',
        overflowX: 'hidden',
        overflowY: 'auto',
        background: theme.colors.grey100,
        paddingTop: '16px',
        paddingBottom: '24px',
      }}
      paddingLeft="s16"
      paddingRight="s16"
      gap="s24"
    >
      {showCarousel ? (
        <ModuleCarousel
          video={hasVideo ? (moduleCarouselVideo ?? undefined) : undefined}
          images={moduleCarouselImages}
          moduleSlug={moduleSlug ?? undefined}
          showPeek={false}
          showTitle={false}
        />
      ) : null}
      {validFeatures.length > 0 ? (
        <Box gap="s16" style={{ width: '100%' }}>
          {validFeatures.map((feature) => (
            <FeatureItem key={feature.title} feature={feature} isCompact />
          ))}
        </Box>
      ) : null}
    </Box>
  )
}
